<div class="item-container" *ngIf="dialogData?.mType == 'dashboard'">
  <div class="item-header">
    <h5 class="text-center">{{"View Company" | translate}}</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content d-flex flex-column">
    <iframe [src]="mainPortalUrl" frameborder="0" width="100%" height="100%"></iframe>
  </div>
</div>

<div #activityLog class=" d-flex h-100 e-box  flex-wrap flex-lg-nowrap" *ngIf="dialogData?.mType == 'setting'">
  <!-- <div class="edit-icons cursor-pointer" mat-dialog-close>
      <i class="material-icons">close</i>
    </div> -->

  <div class="e-left mt-2 mt-lg-0">
    <div class="e-cont mb-3">
      <div class="e-img mt-2 mt-sm-3 mt-md-4" *ngIf="!dialogData?.userData?.company_logo"
        [appBackgroundImg]="empData?.profile_picture"></div>
      <div class="e-img mt-2 mt-sm-3 mt-md-4" *ngIf="dialogData?.userData?.company_logo"
        [appBackgroundImg]="dialogData?.userData?.company_logo"></div>
      <div class="s-header-title mb-0 mt-2 mt-sm-3 text-center">{{dialogData?.userData?.company_name}} {{
        dialogData?.userData?.company_name }}</div>
      <div class="text-center mt-1 e-t">{{dialogData?.userData?.email }}</div>
    </div>

    <div class="emp-sidemenu-cont overflow-auto d-flex flex-column">
      <div class="b-1-5"></div>

      <div class="e-si  cursor-pointer d-flex align-items-center" *ngFor="let item of sideMenu"
        (click)="onSideMenuChange(item)" [ngClass]="{'e-sel':item.id==selectedSideMenu}">
        <i class="material-icons me-1" style="color:black;font-size: 18px;margin-top: -3px;">{{item.icon}}</i>
        <div>{{item.name}}</div>
      </div>
    </div>

  </div>

  <div id="e-right" class="e-right position-relative flex-grow-1 d-flex flex-column">
    <div class="item-header">
      <h6 class="text-center">{{title}}</h6>
      <div class="edit-icons" mat-dialog-close>
        <i class="material-icons">close</i>
      </div>
    </div>
    <!-- <div class="">
        <div class="n-b-cont d-flex flex-wrap gap-3 ">
          <div class="new-b" [ngClass]="{ 'selected': selectedItemId === item.id }" *ngFor="let item of arr" (click)="onMenuBox(item.id)">
            <div class="d-flex align-items-center">
              <div class="new-t">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div> -->
    <div class="d-flex flex-column  flex-grow-1 overflow-auto" *ngIf="!isSpinnerLoading"
      [ngClass]="selectedSideMenu=='2' ? 'flex-grow-1':''">


      <div *ngIf="selectedSideMenu=='3'">
        <div class="d-flex justify-content-between  user-b mb-1 flex-wrap">
          <div class="search-cont gap-2 mt-4 gap-sm-3 ">
            <div class="s-in form-input me-0" style="position:relative">
              <mat-icon class="input-icon">search</mat-icon>
              <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
                (input)="onSearch($event)" (keyup.enter)="onGo()" />
            </div>
            <div class="go-b me-0" (click)="onGo()">Go</div>
          </div>
          <button mat-raised-button color="primary" class="primary-btn mt-4" type="submit"
            (click)="onAddEdit('add','')"><i class="fas fa-plus"></i> Add New </button>
        </div>
        <div class="table-container flex-grow-1 ">
          <table class="" mat-table [dataSource]="dataSource" class="mat-elevation-z8"
            *ngIf="dataSource.data.length!=0">
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef>
                {{"COMMON.CATEGORY"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.j_c }} </td>
            </ng-container>
            <ng-container matColumnDef="sub_category">
              <th mat-header-cell *matHeaderCellDef>
                <div style="max-width: 500px" class="">
                  {{"COMMON.SUBCATEGORY"|translate}} & {{"COMMON.WAGES"|translate}}
                </div>
              </th>
              <td mat-cell *matCellDef="let element">
                <div style="max-width: 500px;">
                  <div class="d-flex align-items-center  cat-box"
                    *ngFor="let item of element.sub_category; let i = index" [ngClass]="{'mt-3':i!=0}">
                    <div class="me-3">{{item.j_sc}}</div>
                    <div class="me-3">
                      <input type="number" min="0" class="form-control" [(ngModel)]="item.wages">
                      <!-- <mat-error>{{item.error}}</mat-error> -->
                    </div>
                    <div>
                      <button mat-raised-button color="warn" class="auth-form-btn  success-btn " type="submit"
                        (click)="onSaveWages(item)">{{"BUTTON.SAVE" | translate}}</button>
                    </div>
                  </div>
                </div>

                {{element.dep }}
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>{{"COMMON.ACTION" | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="action-btn me-2" matTooltip="View" (click)="onAddEdit('edit',element)">
                    <img src="assets/images/icons/edit-icon.svg" class="img-fluid" alt="">
                  </div>
                  <div class="action-btn  cursor-pointer" matTooltip="Edit" (click)="onDeleteItem(element.id)">
                    <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
          </table>
          <div class="mat-table__message" *ngIf="dataSource.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>

      </div>

      <div class="d-flex flex-column align-items-center" *ngIf="selectedSideMenu == '6'">
        <div class="first-main-div first-main-div-2">
          <div class="time-off-settings">
            <div class="section">
              <div class="title "> Overtime setting
              </div>
              <div>Select the overtime rules that best fits your business needs</div>
              <div class="g-card flex-column gap-3 mt-3">
                <div class="title d-flex align-items-center gap-1">
                  <mat-slide-toggle color="primary"
                    [(ngModel)]="generalObj.weekly_overtime.selected"></mat-slide-toggle> Weekly overtime
                </div>
                <div class="border-b"> </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">Start after
                      <input type="number" class="form-control" [(ngModel)]="generalObj.weekly_overtime.value"
                        [disabled]="generalObj.weekly_overtime.selected==false"> Hours/week
                    </span>
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">
                      {{ generalObj.weekly_overtime.s_m == 1 ? 'Multiplier' : 'Additional' }}
                      <input type="number" class="form-control" [(ngModel)]="generalObj.weekly_overtime.s_mv"
                        [disabled]="generalObj.weekly_overtime.selected==false">
                      <mat-select [(ngModel)]="generalObj.weekly_overtime.s_m" class="sel-w ms-2" panelClass="sel-we"
                        [disabled]="generalObj.weekly_overtime.selected==false">
                        <mat-option [value]="1" selected>X base wage</mat-option>
                        <mat-option [value]="2">+ base wage</mat-option>
                      </mat-select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="g-card flex-column gap-3 mt-3">
                <div class="title d-flex align-items-center gap-1">
                  <mat-slide-toggle color="primary" [(ngModel)]="generalObj.daily_overtime.selected"></mat-slide-toggle>
                  Daily overtime
                </div>
                <div class="border-b"> </div>
                <div class="d-flex gap-2">
                  <div class="d-flex align-items-center">on days :</div>
                  <div class="day-buttons">
                    <button *ngFor="let day of workdays"
                      [ngClass]="{ selected: getSelectedDays('daily_overtime',day.value) }"
                      (click)="onAddDaysOvertime('daily_overtime',day)">{{ day.label }} </button>
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">Start after
                      <input type="number" class="form-control" [(ngModel)]="generalObj.daily_overtime.value">
                      Hours</span>
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2"> {{ generalObj.daily_overtime.s_m == 1 ? 'Multiplier'
                      : 'Additional' }}
                      <input type="number" class="form-control" [(ngModel)]="generalObj.daily_overtime.s_mv">
                      <mat-select [(ngModel)]="generalObj.daily_overtime.s_m" class="sel-w ms-2" panelClass="sel-we">
                        <mat-option [value]="1" selected>X base wage</mat-option>
                        <mat-option [value]="2">+ base wage</mat-option>
                      </mat-select>
                    </span>
                  </div>
                </div>
              </div>




              <div class="g-card flex-column gap-3 mt-3">
                <div class="title d-flex align-items-center gap-1">
                  <mat-slide-toggle color="primary" [(ngModel)]="generalObj.premium_time.selected"></mat-slide-toggle>
                  Premium time
                </div>
                <div class="border-b"> </div>
                <div class="d-flex gap-2">
                  <div class="d-flex align-items-center">on days :</div>
                  <div class="day-buttons">
                    <button *ngFor="let day of workdays"
                      [ngClass]="{ selected: getSelectedDays('premium_time',day.value) }"
                      (click)="onAddDaysOvertime('premium_time',day)">{{ day.label }} </button>
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">Start after
                      <input type="number" [(ngModel)]="generalObj.premium_time.value" class="form-control">
                      Hours</span>
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2"> Custom
                      <input type="number" class="form-control" [(ngModel)]="generalObj.premium_time.s_mv">
                    </span>
                  </div>
                </div>
              </div>

              <div class="g-card flex-column gap-3 mt-3">
                <div class="title d-flex align-items-center gap-1">
                  <mat-slide-toggle color="primary"
                    [(ngModel)]="generalObj.night_premium.selected"></mat-slide-toggle>Night Premium
                </div>
                <div class="border-b"> </div>

                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">Between
                      <input type="number" [(ngModel)]="generalObj.night_premium.fr" class="form-control">
                      To <input type="number" [(ngModel)]="generalObj.night_premium.to" class="form-control"></span>
                    <!-- <span class="d-flex align-items-center gap-2">Start after
                      <input type="number" [(ngModel)]="generalObj.night_premium.value" class="form-control">
                      Hours/week</span> -->
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2"> {{ generalObj.night_premium.s_m == 1 ? 'Multiplier'
                      : 'Additional' }}
                      <input type="number" class="form-control" [(ngModel)]="generalObj.night_premium.s_mv">
                      <mat-select class="sel-w ms-2" panelClass="sel-we" [(ngModel)]="generalObj.night_premium.s_m">
                        <mat-option [value]="1" selected>X base wage</mat-option>
                        <mat-option [value]="2">+ base wage</mat-option>
                      </mat-select>
                    </span>
                  </div>
                </div>
              </div>

              <div class="g-card flex-column gap-3 mt-3">
                <div class="title d-flex align-items-center gap-1">
                  <mat-slide-toggle [(ngModel)]="generalObj.partial_day_overtime.selected"
                    color="primary"></mat-slide-toggle> Partial day overtime
                </div>
                <div class="border-b"> </div>
                <div class="d-flex gap-2">
                  <div class="d-flex align-items-center">on days :</div>
                  <div class="day-buttons">
                    <button *ngFor="let day of workdays"
                      [ngClass]="{ selected: getSelectedDays('partial_day_overtime',day.value) }"
                      (click)="onAddDaysOvertime('partial_day_overtime',day)"> {{ day.label }} </button>
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">Start after
                      <input type="number" class="form-control" [(ngModel)]="generalObj.partial_day_overtime.fr">
                      Hours <input type="number" class="form-control"
                        [(ngModel)]="generalObj.partial_day_overtime.to"></span>
                    <!-- <span class="d-flex align-items-center gap-2">Start after
                      <input type="number" class="form-control" [(ngModel)]="generalObj.partial_day_overtime.value">
                      Hours</span> -->
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2"> {{ generalObj.partial_day_overtime.s_m == 1 ?
                      'Multiplier' : 'Additional' }}
                      <input type="number" class="form-control" [(ngModel)]="generalObj.partial_day_overtime.s_mv">
                      <mat-select [(ngModel)]="generalObj.partial_day_overtime.s_m" class="sel-w ms-2"
                        panelClass="sel-we">
                        <mat-option [value]="1" selected>X base wage</mat-option>
                        <mat-option [value]="2">+ base wage</mat-option>
                      </mat-select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="g-card flex-column gap-3 mt-3">
                <div class="title d-flex align-items-center gap-1">
                  <mat-slide-toggle color="primary"
                    [(ngModel)]="generalObj.consecutive_days_overtime.selected"></mat-slide-toggle>
                  Consecutive day overtime
                </div>
                <div class="border-b"> </div>
                <div class="d-flex gap-2">
                  <div class="d-flex align-items-center">on days :</div>
                  <div class="day-buttons">
                    <button *ngFor="let day of workdays"
                      [ngClass]="{ selected: getSelectedDays('consecutive_days_overtime',day.value) }"
                      (click)="onAddDaysOvertime('consecutive_days_overtime',day)"> {{ day.label }} </button>
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">Start on the
                      <input type="number" class="form-control"
                        [(ngModel)]="generalObj.consecutive_days_overtime.st_on"> Consecutive day</span>

                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">Start after
                      <input type="number" class="form-control"
                        [(ngModel)]="generalObj.consecutive_days_overtime.value"> Hours</span>
                  </div>
                </div>

                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">
                      {{ generalObj.consecutive_days_overtime.s_m ==1 ? 'Multiplier' : 'Additional' }}
                      <input type="number" class="form-control" [(ngModel)]="generalObj.consecutive_days_overtime.s_mv">
                      <mat-select [(ngModel)]="generalObj.consecutive_days_overtime.s_m" class="sel-w ms-2"
                        panelClass="sel-we">
                        <mat-option [value]="1" selected>X base wage</mat-option>
                        <mat-option [value]="2">+ base wage</mat-option>
                      </mat-select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="g-card flex-column gap-3 mt-3">
                <div class="title d-flex align-items-center gap-1">
                  <mat-slide-toggle color="primary"
                    [(ngModel)]="generalObj.pay_period_overtime.selected"></mat-slide-toggle>
                  Pay period overtime
                </div>
                <div class="border-b"> </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">Start after
                      <input type="number" class="form-control" [(ngModel)]="generalObj.pay_period_overtime.value">
                      Hours/week</span>
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div for="requiresApproval" class="description">
                    <span class="d-flex align-items-center gap-2">
                      {{ generalObj.pay_period_overtime.s_m == 1 ? 'Multiplier' : 'Additional' }}
                      <input type="number" class="form-control" [(ngModel)]="generalObj.pay_period_overtime.s_mv">
                      <mat-select [(ngModel)]="generalObj.pay_period_overtime.s_m" class="sel-w ms-2"
                        panelClass="sel-we">
                        <mat-option [value]="1" selected>X base wage</mat-option>
                        <mat-option [value]="2">+ base wage</mat-option>
                      </mat-select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <button mat-raised-button color="primary" class="auth-form-btn" type="submit"
          (click)="onSubmitRules()">{{"BUTTON.SAVE" |
          translate
          }}</button>
      </div>

    </div>

    <div *ngIf="isSpinnerLoading" class="custom-loader"></div>

  </div>

</div>